import _ from 'lodash';
import {togglePageModal} from 'common/actions/PageActions';

export const mapStateToProps = (state, props) => {
  const { app, page } = state;
  const { modalId } = props;
  const activePage = _.get(app, 'activeRoute.name', null);
  return {
    isOpen: _.get(page, [activePage, 'modal', modalId], false)
  };
};

export const mapDispatchToProps = (dispatch, props) => {
  return {
    closeModal: () => {
      const { modalId } = props;
      dispatch(togglePageModal(modalId, false));
    }
  };
};
